import { connect } from 'react-redux';
import GenericLoader from '../util/GenericLoader';
import { getKeysAndScopesAction } from '../../redux/actions/apiKeys';

const mapDispatchToProps = (dispatch) => ({
  fetchFunction: () => dispatch(getKeysAndScopesAction()),
});

export default connect(null, mapDispatchToProps)(GenericLoader);
